/*
=========================================================
* Otis Kit PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// react-countup component
import CountUp from "react-countup";

// Otis Kit PRO components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultCounterCard({ color = "info", count, title = "", description = "",suffix,  ...rest }) {
  return (
    <MKBox p={2} textAlign="center" lineHeight={1} sx={{flex: "1 1 auto"}} >
      <MKTypography variant="h2" color={color} textGradient>
        <CountUp start={0}
          end={count}
          duration={1}
          suffix={suffix}
          formattingFn={(value) => {
            const hours = Math.floor(value / 60);
            const minutes = Math.floor(value % 60);
            // Returns "5:30" with padded minutes
            return `${hours}:${minutes.toString().padStart(2, '0')} ${suffix}`;
          }}
          {...rest} />
      </MKTypography>
      {title && (
        <MKTypography variant="h6" mt={2} mb={1}>
          {title}
        </MKTypography>
      )}
      {description && (
        <MKTypography variant="body2" color="text">
          {description}
        </MKTypography>
      )}
    </MKBox>
  );
}

// Typechecking props for the DefaultCounterCard
DefaultCounterCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  count: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DefaultCounterCard;
